/**
 * TreeMapEditor
 *
 * Property editor for tree map configuration
 */

import React from 'react';
import { ChartBaseEditor, type ChartBaseConfig } from './ChartBaseEditor';
import { TextPropertyEditor } from '../../BaseEditors/TextPropertyEditor';

export interface TreeMapEditorProps {
  config: Partial<ChartBaseConfig & {
    labelKey?: string;
    valueKey?: string;
  }>;
  onChange: (config: Partial<ChartBaseConfig>) => void;
}

export const TreeMapEditor: React.FC<TreeMapEditorProps> = ({ config, onChange }) => {
  return (
    <ChartBaseEditor config={config} onChange={onChange} chartType="Tree Map" showAxes={false}>
      <div className="chart-editor__section">
        <h3 className="chart-editor__section-title">Tree Map Options</h3>

        <TextPropertyEditor
          label="Label Key"
          value={(config.labelKey as string) || 'label'}
          onChange={(labelKey) => onChange({ ...config, labelKey })}
          helpText="Property for rectangle labels"
          required
        />

        <TextPropertyEditor
          label="Value Key"
          value={(config.valueKey as string) || 'value'}
          onChange={(valueKey) => onChange({ ...config, valueKey })}
          helpText="Property for area size (numeric)"
          required
        />
      </div>
    </ChartBaseEditor>
  );
};

TreeMapEditor.displayName = 'TreeMapEditor';
